import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showTransactionsForm, setShowTransactionsForm ] = useState(false)
    const [ modalOpeningMode, setModalOpeningMode ] = useState('EDITABLE')

    return Object.freeze({
        showTransactionsForm, setShowTransactionsForm,
        modalOpeningMode, setModalOpeningMode
    })
}